import React from 'react';
import eventBus from '../../service/eventBus';
import { EVENT_UPDATE_ACTION_BAR_VIEW } from '../../utils/constants';
import globalStyles from '../globals.module.css';
import componentStyles from './accessLockedPanel.module.css';

const AccessLockedPanel = ({
    title = 'Pro Access Required',
    message = 'Upgrade to Pro to unlock this workflow.',
    actionLabel = 'Upgrade to Pro',
    actionView = 'profile',
    onAction = null,
    secondaryLabel = '',
    secondaryView = '',
    onSecondaryAction = null
}) => {
    const handleAction = (view) => {
        if (onAction && view === actionView) {
            onAction();
            return;
        }

        if (onSecondaryAction && view === secondaryView) {
            onSecondaryAction();
            return;
        }

        if (view) {
            eventBus.emit(EVENT_UPDATE_ACTION_BAR_VIEW, view);
        }
    };

    return (
        <section className={`${globalStyles.standardSection} ${componentStyles.lockedPanel}`}>
            <div className={componentStyles.statusLabel}>Access control // restricted</div>
            <h3 className={globalStyles.sectionHeader}>{title}</h3>
            <div className={componentStyles.message}>
                {message}
            </div>
            <div className={`${globalStyles.actionButtonsRow} ${componentStyles.actions}`}>
                <button
                    type="button"
                    className={globalStyles.primaryButton}
                    onClick={() => handleAction(actionView)}
                >
                    {actionLabel}
                </button>
                {secondaryLabel && secondaryView && (
                    <button
                        type="button"
                        className={globalStyles.secondaryButton}
                        onClick={() => handleAction(secondaryView)}
                    >
                        {secondaryLabel}
                    </button>
                )}
            </div>
        </section>
    );
};

export default AccessLockedPanel;
